import {useHistory} from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Card, CardContent, FormControl, FormControlLabel,
    Grid, IconButton, InputLabel, Radio, RadioGroup, Select as MaterialSelect,
    TextField, Tooltip, Typography, LinearProgress } from '@material-ui/core'
//import TablaOrden from './TablaOrden';
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import Relojes from './Relojes2'
import {ErrorGeneral, llamadaApiToken, llamaApiCargaToken} from '../funciones/ClienteAxios';
import React, {useContext, useEffect, useState, useRef} from "react";
//import TablaBitacora from "./TablaBitacora.jsx";
import NumberFormat from 'react-number-format';

import Grafica from './Grafica'
import TablaObra from "./TablaObra";
import Mapa from "../mapa";
import MapaTodos from "../mapa/MapaTodos";
import ModalDetalle from "./ModalDetalle";
const useStyles = makeStyles((theme) => ({
    title2: {
        fontSize: 18,
    },
    subTitle2: {
        fontSize: 12,
    },
    altura2: {
        minHeight: 70,
        marginTop: 0,
        paddingTop: 0,
    },
    altura3: {
        minHeight: 145,
        marginTop: 0,
        paddingTop: 0,
    },
    card:{
        height:'5.1rem',
        width:120,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card3:{
        height:'5.1rem',
        width:170,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card4:{
        height:'6rem',
        width:170,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    titulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-.4rem',
        fontSize:'1rem',
        fontWeight:600
    },
    tituloColor:{

        //color:'white',
        textAlign:'center',
        marginTop:'-.2rem',
        fontSize:'1.2rem',
        fontWeight:600
    },
    subtituloCard:{
       // color:'#4a4a4a',
       fontWeight:600,
        textAlign:'center',
        marginTop:'.4rem',
        fontSize:'.97rem',
    },
}));


const Dashboard = () => {
    let history = useHistory();
    const classes = useStyles();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
 const markerRef = useRef()
    const {usuario, guardarUsuario} = useContext(AuthContext);
    const {guardarGenerales} = useContext(GeneralesContext);
    const [listBit, setListBit] = useState([])
    const [ordenBusq, setOrdenBusq] = useState({orden: '', turno: ''});
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({inicio: new Date(), final: new Date()});
    const {orden, turno} = ordenBusq;
    const [estatus, setEstatus] = useState(-2);
    const [buscar, setBuscar] = useState(true);
    const [terminal, setTerminal] = useState([]);
    const [totales, setTotales] = useState([])
    const [modalAbierto, setModalAbierto] = useState(false);
    const [espera, setEspera] = useState(false);
    const[filtro,setFiltro] = useState({supervisa:false})
    const [listTipoMaq, setListTipoMaq] = useState([]);
    const [obraRegis, setObraRegis] = useState([]);
    const [obraRegis2, setObraRegis2] = useState([]);
    const [regisDetalle, setRegisDetalle] = useState([]);
    const [contador, setContador] = useState(1);
    const{supervisa}=filtro

    useEffect(() => {                       

        const veriSesion = () => {
            const usu = localStorage.getItem('UsuarioNom');
            const nvl = localStorage.getItem('Tipo');
            if (usu === null) {
                guardarUsuario([])
                guardarGenerales([])
                localStorage.clear();
                history.push("/")
            } else {
                if (usuario.length === 0) {
                    guardarUsuario({Nombre: usu, nivel: nvl});
                }

                guardarGenerales({Titulo: 'Inicio'})
                
            }
        }
        veriSesion();
        return () => {
            source.cancel();
        }
    }, []);

    useEffect(()=>{
        setObraRegis2(obraRegis)
    },[obraRegis])

    useEffect(()=>{
        getTotales()
    },[buscar])

    const getTotales = () => {
        const fInicio1=moment(fechasSeleccionadas.inicio).format("YYYY-MM-DD")
        const fFinal1=moment(fechasSeleccionadas.final).format("YYYY-MM-DD")
        const data = qs.stringify({
            Usuario: idusu,
            ip: "127.0.0.0",
            FIni: `${fInicio1}T00:00:00`,
            FFin: `${fFinal1}T23:59:59`,  
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/dashboard";

        function respuestaListTermin(aux) {
            if (aux[0].length !== 0) {                
                setTotales(aux[0])
                setListTipoMaq(aux[0].Ubicacion[0].Tipo)
            }
        }

        llamaApiCargaToken(data, url, respuestaListTermin, ErrorGeneral, setEspera, history, source)
    };     

    const onChange = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            setOrdenBusq({
                ...ordenBusq,
                [e.target.name]: e.target.value.trim()
            })
        }

    };

    const incrementarBuscar = e => {
        setBuscar(!buscar)
    };

    const onChangeTerminal = (event) => {
        setTerminal(event.target.value);
    };


 

    const Encabezado = ({espacio, estiloCampo, descripcion, campo}) => {
        return (
        <Box {...espacio} >
            <Typography className={classes.title2} variant="h5" color="secondary"
                component="h2" align="center" style={estiloCampo}
            >
                {campo}
            </Typography>
            <Typography className={classes.subTitle2} color="textSecondary" align="center">
                {descripcion}
            </Typography>
        </Box>
        )
    }

    const CampoRenglon = ({estiloBox, estiloTitulo, titulo, campo}) => {
        return (
            <Box  {...estiloBox} >
                <span style={estiloTitulo}>{titulo} </span>
                <Typography variant='body'> {campo}  </Typography>
            </Box>
        )
    }

    function generarCards(mensaje, datGen, auxColor){
        return( 
        <CardContent>
            <Box display="flex" style={{justifyContent:"center", width:"100%"}}>
            <Card className={classes.tituloColor} 
                style={{backgroundColor:auxColor,color:'white', width:"4.7rem", height:"2rem", alignContent:"center" }} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>                
            </Card>
            </Box>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }

    function generarCards2(mensaje, datGen, auxColor){
        return( 
        <CardContent >
            <Box display="flex" style={{justifyContent:"center", width:"100%"}}>
            <Card className={classes.tituloColor} 
                style={{backgroundColor:auxColor,color:'white', width:"6rem", height:"2rem", alignContent:"center"}} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>                
            </Card>
            </Box>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>        
        </CardContent>
        )
    }

    function generarCards3(mensaje, datGen, auxColor, Tipo, Categoria){
        return( 
        <CardContent onClick={()=>handleAbrir(obraRegis2, obraRegis2.Id, Tipo, Categoria, mensaje)}>
            <Box display="flex" style={{justifyContent:"center", width:"100%"}}>
            <Card className={classes.tituloColor} 
                style={{backgroundColor:auxColor,color:'white', width:"6rem", height:"2rem", alignContent:"center"}} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>                
            </Card>
            </Box>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>        
        </CardContent>
        )
    }

    const leyendaSeleccionada=(mensaje)=>{

        return(
        <Box mt={1} ml={1}>
        
            <Card // className={classes.tituloColor}  
                style={{width:"22rem", height:"2rem", alignContent:"center"}} 
            >                
            <CardContent style={{padding:0}} >            
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>            
            </CardContent>
            </Card>                                
        </Box>
        )
    }

    const costadoDerecho = (orden) => {
        let fecha = moment.utc(orden.fecha);
        let modificada = fecha.local(true).format("DD/MM/YYYY");        
        const colorTitulo = process.env.REACT_APP_COLOR        
        return (
            <span>
        <Box pl={1} my={1}>
            <Card  >
                <CardContent>
                    <Box display="flex" flexDirection="row" justifyContent="center">
                        <Encabezado espacio={{}} estiloCampo={{fontWeight: '900'}} descripcion={"OT"} campo={orden.Id}/>
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                            descripcion={"Periodo"} campo={orden.periNom}/>
                        {/* <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                                    descripcion={"Sección"} campo={orden.seccNom}/> */}
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                                    descripcion={"Lugar"} campo={orden.lugarDescr}/>
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                                    descripcion={"Fecha"} campo={modificada}/>                                                           
                    </Box>
                    {orden.refManual.length !== 0 && orden.refManual !== ' ' ?
                        <CampoRenglon estiloBox={{display: "flex"}} titulo="Ref. Manual " campo={orden.refManual}
                                      estiloTitulo={{color: colorTitulo, fontWeight: 700, paddingRight: 0.2 + 'rem'}}
                        />
                        : null}
                    {orden.ubicDescr.length !== 0 ?
                        <CampoRenglon estiloBox={{display: "flex"}} titulo="Ubicación " campo={orden.ubicDescr}
                                      estiloTitulo={{color: colorTitulo, fontWeight: 700, paddingRight: 0.2 + 'rem'}}
                        />
                        : null}                    
                </CardContent>                     
            </Card>
        </Box>                    
                          
    </span>)
    }

    const funcionActuliza = () => {
        setBuscar(!buscar)
    }

    function handleAbrir(registro, Obra,Tipo, Categoria, leyenda) {
        setRegisDetalle({...registro, Obra:Obra, Tipo:Tipo, Categoria:Categoria, leyenda})
        setModalAbierto(true)
    }

    const onChangeCheck = (event) => {
        setFiltro({
          ...filtro,
            [event.target.name]: event.target.checked 
          });
    };

    const cardsTotal=()=>{
        return(
        totales.length!=0 && totales.Ubicacion && totales.Ubicacion.length !== 0?
            <Box display={"flex"} flexDirection={"row"}>
                
                <Card className={classes.card} style={{marginRight:".5rem"}}>
                    {generarCards('Obras', totales.Ubicacion[0].ObraTotal, "#696665")}
                </Card>
                
                {totales.Ubicacion[0].EstadoTotal ? 
                <Card className={classes.card}>
                    {generarCards('Estados', totales.Ubicacion[0].EstadoTotal,"#696665")}
                </Card>
                :null}
                {totales.Estatus.length!==0?
                    totales.Estatus.map((objeto)=>{
                    return<Card className={classes.card3} style={{marginRight:".5rem", marginLeft:".5rem"}}>
                        {generarCards2(objeto.Descr, objeto.Total,objeto.Color)}
                    </Card> 
                    })
                :null}
            </Box>
        :null)
    }

    const minuscula=(cadena)=>{
        let nvo=""
        nvo = cadena.substring(0,1) + cadena.substring(1,cadena.length).toLowerCase()
        return nvo
    }

    const cardRegistro=()=>{
        return(
        listTipoMaq.length !== 0?
            <Box display={"flex"} flexDirection={"column"} >                        
            <Box display={"flex"} flexDirection={"row"} >
            {listTipoMaq.map((objeto)=>{
                return<Card className={classes.card4} style={{marginRight:".5rem", marginLeft:".5rem"}} key={objeto.Id}>
                    {generarCards3(minuscula(objeto.Nom), obraRegis2[`Maq${objeto.Id}Tot`], "#F58634",  objeto.Id, 0)}
                </Card> 
            })
            }
            </Box>
            <Box  display={"flex"} flexDirection={"row"} mt={2}>
            <Card className={classes.card4} style={{marginRight:".5rem", marginLeft:".5rem"}}>
                {generarCards3("Estatus Off", obraRegis2[`StatusOff`], "#F58634", obraRegis2.Id, 2)}
            </Card> 
            <Card className={classes.card4} style={{marginRight:".5rem", marginLeft:".5rem"}}>
                {generarCards3("Estatus On", obraRegis2[`StatusOn`], "#F58634", obraRegis2.Id, 1)}
            </Card> 
            <Card className={classes.card4} style={{marginRight:".5rem", marginLeft:".5rem"}}>
                {generarCards3("Estatus Taller", obraRegis2[`StatusTaller`], "#F58634", obraRegis2.Id, 3)}
            </Card> 
            </Box>
            </Box>
        :null)
    }

    const principal = () => {
        return (    
        <Box  display={"flex"}  alignItems={'flex-start'} >
            <Box display={"flex"}  flexDirection={"column"}>
                <Box display={"flex"}  flexDirection={"row"}>
                <Box   display="flex" alignItems={'center'} flexDirection={"row"} >                            
                    <Box  >
                        <Tooltip title="Buscar">
                        <IconButton color="primary" size={"small"} onClick={incrementarBuscar}
                            style={{paddingTop: '.6rem'}}>
                            <SearchIcon/>
                        </IconButton>
                        </Tooltip>
                    </Box>                     
                    <Box   component="span" style={{width:"16rem"}} >                                                                                                                                            
                        <Relojes fechasSeleccionadas={fechasSeleccionadas} setFechasSeleccionadas={setFechasSeleccionadas} />
                    </Box> 
                    {espera ? <Box width={"27rem"} ml={2} > <LinearProgress/> </Box> : cardsTotal()}   
                </Box>
                
                </Box>
                <Box display={"flex"} flexDirection={"row"}>
                    {espera ? <Box width={"32rem"} ml={2} mt={5}> <LinearProgress/> </Box> 
                    :   totales.length!=0 && totales.Ubicacion && totales.Ubicacion.length !== 0? 
                            <TablaObra listBit={totales.Ubicacion[0].Obras} 
                                obraRegis={obraRegis} setObraRegis={setObraRegis} />
                        :null    
                    }
                    <Box display={"flex"} flexDirection={"column"} style={{marginLeft:"1rem"}}>
                        <Box>
                            {obraRegis2.length !== 0 && obraRegis2.Id !==0 ? leyendaSeleccionada(obraRegis2.Descr):null}
                        </Box>
                        <Box mt={2}>
                            {obraRegis2.length !== 0 ? cardRegistro() :null}
                        </Box>
                       {  obraRegis.length!==0 && obraRegis.Id !==0 ?
                        <Box mt={2} ml={2}>
                            <Mapa registro={{long: obraRegis.Lon, lat:obraRegis.Lat, original:obraRegis}} />
                        </Box>:null  }
                        {  obraRegis.length!==0 && obraRegis.Id ===0 ?
                        <Box mt={2} ml={2}>
                            <MapaTodos lista={totales.Ubicacion[0].Obras} setObraRegis2={setObraRegis2} contador={contador} setContador={()=>setContador(contador+1)}/>
                        </Box>:null  }
                    </Box>
                </Box>
            </Box>
            <Box   style={{paddingLeft:".5rem"}}>                
               
            </Box>           
        </Box>              
        )
    }

    const modDet = modalAbierto ? <ModalDetalle modalAbierto={modalAbierto} setModalAbierto={setModalAbierto} titulo={`Detalle ${regisDetalle?.leyenda}`}  registro={regisDetalle} />:null
    return (
    <>
    {modDet}
        {principal()}
        
    </>
    )
}

export default Dashboard